import * as React from "react"
import Accordion from "@mui/material/Accordion"
import AccordionDetails from "@mui/material/AccordionDetails"
import AccordionSummary from "@mui/material/AccordionSummary"
import Box from "@mui/material/Box"
import Container from "@mui/material/Container"
import Link from "@mui/material/Link"
import Typography from "@mui/material/Typography"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { FAQ_SECTION, FAQ_ITEMS, BRAND } from "@/features/landing/content"

export default function FAQ() {
  const [expanded, setExpanded] = React.useState<string[]>([])

  const handleChange = (panel: string) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? [...expanded, panel] : expanded.filter(item => item !== panel))
  }

  return (
    <Container
      id="faq"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: { xs: 3, sm: 6 }
      }}>
      <Typography
        component="h2"
        variant="h4"
        sx={{
          color: "text.primary",
          width: { sm: "100%", md: "60%" },
          textAlign: { sm: "left", md: "center" }
        }}>
        {FAQ_SECTION.heading}
      </Typography>
      <Box sx={{ width: "100%" }}>
        {FAQ_ITEMS.map((faq, index) => {
          const panelId = `panel${index + 1}`
          return (
            <Accordion key={panelId} expanded={expanded.includes(panelId)} onChange={handleChange(panelId)}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`${panelId}d-content`}
                id={`${panelId}d-header`}>
                <Typography component="span" variant="subtitle2">
                  {faq.question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2" gutterBottom sx={{ maxWidth: { sm: "100%", md: "70%" } }}>
                  {faq.answer}
                </Typography>
              </AccordionDetails>
            </Accordion>
          )
        })}
        {/* Support contact accordion */}
        <Accordion expanded={expanded.includes("panelSupport")} onChange={handleChange("panelSupport")}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panelSupportd-content"
            id="panelSupportd-header">
            <Typography component="span" variant="subtitle2">
              How do I contact customer support?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2" gutterBottom sx={{ maxWidth: { sm: "100%", md: "70%" } }}>
              Email us at&nbsp;
              <Link href={`mailto:${BRAND.supportEmail}`}>{BRAND.supportEmail}</Link>
              &nbsp;or join our WhatsApp channel for quick replies.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Box>
    </Container>
  )
}
